import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FileIcon from '@/shared/components/FileIcon';
import { ModalType, useModalContext } from '@/shared/providers/ModalProvider';
const TaskAttachmentsPopover = ({ attachments, loadingAttachments, }) => {
    const { setShowModalInfo } = useModalContext();
    return (_jsxs("span", Object.assign({ id: "popover-trigger-hover-focus" }, { children: [loadingAttachments ? _jsx("i", { className: "fa fa-spin fa-spinner" }) : null, attachments
                ? attachments.map(document => (_jsx("div", { children: _jsx("a", Object.assign({ onClick: e => {
                            setShowModalInfo({
                                modalType: ModalType.DocumentDetail,
                                documentId: document.id,
                            });
                            e.stopPropagation();
                        } }, { children: _jsxs("span", Object.assign({ className: "text-nowrap" }, { children: [_jsx(FileIcon, { document: document }), " ", document.name] })) })) }, document.id)))
                : null] })));
};
export default TaskAttachmentsPopover;
